export default __webpack_public_path__ + "static/PromptIconSeven-5524237a37544ba475c4b7daba559270.png";